import React from 'react';
import { ButtonContainerV2, Loading } from './styles';

import IconPlusWhite from '../../assets/icons/iconAddHeader.svg';
import IconPlusGray from '../../assets/icons/icon-plus-gray.svg';
import { TaglineM, TaglineMSpan } from '../../styles/stylesTypography';
import { theme } from '../../styles/theme';

const Button = ({ id, ...props }) => {

    return(
        <ButtonContainerV2
            width={props.width}
            height={props.height}
            maxWidth={props.maxWidth}
            disabled={props.disabled}
            outline={props.outline}
            loading={props.loading}
            red={props.red}
            blog={props.blog}
            color={props.color}
            tooltipMarginLeft={props.tooltipMarginLeft}
            margin={props.margin}
        >

            <button type="button" className='btnv2' id={id} onClick={props.onClick ? () => props.onClick() : undefined} {...props} disabled={props.disabled || props.loading}>
                
                  {props.loading === true ? ("") : (
                        props.iconNode ? (
                            props.iconNode
                        ) : props.icon ? (
                            props.iconHover ? (
                                <>
                                    <img className="icon-default" src={props.icon} alt="" />
                                    <img className="icon-hover" src={props.iconHover} alt="" />
                                </>
                            ) : (
                                <img src={props.icon} alt="" />
                            )
                        ) : props.imagePlus ?
                            !props.disabled ? (
                                <img src={IconPlusWhite} alt="Ícone de adicionar" />
                            ): (
                                <img src={IconPlusGray} alt="Ícone de adicionar" />
                            ) : null
                  )}
                

                {props.loading === true ? (
                    <Loading
                        disabled={props.disabled}
                        outline={props.outline}
                        red={props.red}
                        loaderColor={props.loaderColor}
                    />
                ) : (
                    <TaglineMSpan
                    color={props.disabled ? theme.colors.disabled.Desabilitado_Medio : 
                        props.outline ? props.red === true ? theme.colors.red.Vermelho_erro : 
                        props.color ? props.color : theme.colors.green.Verde_AgroReceita : 
                        props.blog ? theme.colors.green.Verde_AgroReceita :  theme.colors.white.Branco}
                    >
                        {props.value}
                    </TaglineMSpan>
                )}
            </button>

            {props.disabled === true && props.tooltip === true && props.tooltipMsg ? (
                <p>{props.tooltipMsg}</p>
            ) : (props.tooltip === true && props.showTooltipMsg ? (
                <p>{props.showTooltipMsg}</p>
            ) : (null))}
        </ButtonContainerV2>
    )
}

export default Button;